import React from "react";
import { Button, Dimmer, Header, Image, Loader, Message } from "semantic-ui-react";
import logo from "../../assets/images/urbansim/logo.png";

type AcceptInvitationProps = {
  onAccept: () => void;
  invitation: any;
  loading: boolean;
  showSuccessMessage: boolean;
  successMessageHeader: string;
  successMessageContent: string;
};

const AcceptInvitation = ({
  onAccept,
  invitation,
  loading,
  showSuccessMessage,
  successMessageHeader,
  successMessageContent
}: AcceptInvitationProps) => {
  return (
    <>
      <Image size="small" src={logo} style={{ margin: "auto", display: "inline-block" }} />
      <Header as="h1" textAlign="center">
        UrbanSim
      </Header>
      <p>
        Accept invitation to join {invitation.role.region.name} as {invitation.role.name}?
      </p>
      <Dimmer active={loading}>
        <Loader />
      </Dimmer>
      {showSuccessMessage && (
        <Message positive>
          <Message.Content>
            <Message.Header>{successMessageHeader}</Message.Header>
            {successMessageContent}
          </Message.Content>
        </Message>
      )}
      <Button color="green" onClick={() => onAccept()} style={{ display: "inline-block" }}>
        Accept
      </Button>
    </>
  );
};

export default AcceptInvitation;
